import { CACHE_KEYS } from "@repo/api-services/CacheKeys";
import { handleGlobalGetRequestQuery } from "@repo/api-services/getRequestsGlobal.ts";
import URLS from "@repo/api-services/URLS";
import { useQuery } from "@tanstack/react-query";
import { IExecutiveDashboardResponse } from "./executiveSignals.types";

interface UseExecutiveSignalsProps {
  createdBetween?: string;
}

const useGetAllExecutiveSignals = ({
  createdBetween,
}: UseExecutiveSignalsProps) => {
  const getAllExecutivesignals = useQuery<IExecutiveDashboardResponse>({
    queryKey: [...CACHE_KEYS.EXECUTIVE_SIGNALS, createdBetween],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.EXECUTIVE_SIGNALS,
        searchParams: {
          ...(createdBetween && { "filter[created_between]": createdBetween }),
        },
      }),
  });

  return {
    services: {
      getAllExecutivesignals,
    },
  };
};

export { useGetAllExecutiveSignals };
